'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionCard = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var OptionCard = function OptionCard(_ref) {
  var id = _ref.id,
      image = _ref.image,
      title = _ref.title,
      selected = _ref.selected,
      imageTop = _ref.imageTop,
      imageLarge = _ref.imageLarge,
      props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'image', 'title', 'selected', 'imageTop', 'imageLarge']);

  return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
    className: (0, _classnames2.default)('frm-OptionCard', {
      'frm-OptionCard-active': selected,
      'frm-OptionCard-imageTop': imageTop
    })
  }), image && _react2.default.createElement('img', {
    className: (0, _classnames2.default)('frm-OptionCard_Image', {
      'frm-OptionCard_Image-large': imageLarge
    }),
    src: image
  }), _react2.default.createElement('p', { className: 'frm-OptionCard_Title' }, title));
};

exports.OptionCard = OptionCard;
OptionCard.defaultProps = {
  id: null,
  image: null,
  selected: false,
  imageTop: false,
  imageLarge: false
};

OptionCard.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  image: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  selected: _propTypes2.default.bool,
  imageTop: _propTypes2.default.bool,
  imageLarge: _propTypes2.default.bool
};